import { IPresets } from 'modules/template-editor/domain/consts/form/presets';

export enum BoardPresets {
  create = 'create',
  edit = 'edit',
  duplicate = 'duplicate',
  copy = 'copy',
  delete = 'delete',
}

export const boardPresets: Record<BoardPresets, IPresets> = {
  create: {
    header: 'Новое табло',
    submitButton: 'Создать',
  },
  edit: {
    header: 'Редактирование табло',
    submitButton: 'Сохранить',
  },
  duplicate: {
    header: 'Дублирование табло',
    submitButton: 'Дублировать',
  },
  copy: {
    header: 'Копирование табло',
    submitButton: 'Скопировать',
  },
  delete: {
    header: 'Удаление табло',
    submitButton: 'Удалить',
  },
};
